'use strict'

import ApiClient from './ApiClient'

export default class InformationSettingsRepository {
  /**
   * お知らせの設定を取得
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/information-settings`)
  }

  /**
   * お知らせの設定を更新
   * @param params sendData
   * @returns {*}
   */
  put (params) {
    return ApiClient().put(`/information-settings`, params)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/InformationSettingsRepository.js